import { CheckboxStore } from '../../../../../stores/CheckboxStore'
import SinglePageSwitcherStore from '../../../../Customers/store/CustomersStore'

export const newRequestsSwitcherStore = new SinglePageSwitcherStore()
export const newRequestsCheckboxStore = new CheckboxStore()
